import cx from 'classnames';
const HomeArticles = ({ containerClass, articles = [], }) => {
    return (<div className={cx(containerClass)}>
      {articles.map(({ article }) => (<article className="home-article" id={article.id} key={article.id}>
          <h2 className="home-article-title-left">{article.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: article.body }} className="home-article-info"/>
        </article>))}
    </div>);
};
export default HomeArticles;
